export default "__VITE_PUBLIC_ASSET__603d8e80__"